import * as React from "react";

function SvgSquare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M24.01 4.5v15a4.51 4.51 0 01-4.5 4.5h-15a4.33 4.33 0 01-3.18-1.32A4.33 4.33 0 01.01 19.5v-15a4.35 4.35 0 011.31-3.18A4.37 4.37 0 014.5-.01h15a4.37 4.37 0 013.18 1.32 4.35 4.35 0 011.33 3.19z" />
    </svg>
  );
}

const MemoSvgSquare = React.memo(SvgSquare);
export default MemoSvgSquare;
